import { useTranslation } from 'react-i18next'

import { ButtonContinue } from 'shared/ui/bottom-continue'
import { CardSelectSmall } from 'shared/ui/card-select-small'
import { HeaderResetButton } from 'shared/ui/header-reset-button'

import { SelectedGuides } from '../..'

import s from './styles.module.scss'

type Props = {
  onBack?: () => void
  onReset?: () => void
  onSelect: (value: number) => void
  onApply?: () => void
  titleKey: string

  state?: SelectedGuides[]
  canDisabled?: boolean | undefined
}

export const ExcursionsFilterCarrierUi = ({
  canDisabled,
  onBack,
  onReset,
  state,
  onSelect,
  onApply,
  titleKey,
}: Props) => {
  const { t } = useTranslation()
  return (
    <div className={s.container}>
      <div className={s.header}>
        <HeaderResetButton
          isCanDisable={canDisabled}
          title={t(titleKey)}
          onBack={onBack}
          onReset={onReset}
        />
      </div>

      <div className={s.list}>
        {state?.map((option, index) => (
          <div
            key={option?.id}
            onClick={() => onSelect(index)}
          >
            <CardSelectSmall
              name={option?.name}
              icon={option?.logo_url}
              isSelected={option?.selected}
            />
          </div>
        ))}
      </div>

      <ButtonContinue onClick={onApply}>
        <span className={'semi-bold-16'}>{t('apply')}</span>
      </ButtonContinue>
    </div>
  )
}
